// India Standard Time (UTC+5:30) date helpers.
//
// The app is used in India and the backend buckets every day by IST. Clients
// must therefore compute "today" in IST too — NOT via `new Date().toISOString()`
// which is UTC and, between 00:00 and 05:30 IST, still reads as *yesterday*.
//
// Date.now() is a timezone-independent epoch value; shifting it by +5:30h and
// reading the UTC date portion yields the IST calendar date on any device,
// regardless of the device's own timezone.
const IST_OFFSET_MS = (5 * 60 + 30) * 60 * 1000;

/** Today's date in IST as "YYYY-MM-DD". */
export const istToday = () => new Date(Date.now() + IST_OFFSET_MS).toISOString().slice(0, 10);

/** Current IST month as "YYYY-MM". */
export const istMonth = () => new Date(Date.now() + IST_OFFSET_MS).toISOString().slice(0, 7);
